import { render, staticRenderFns } from "./onsale.vue?vue&type=template&id=30a25b66&scoped=true"
import script from "./onsale.vue?vue&type=script&lang=js"
export * from "./onsale.vue?vue&type=script&lang=js"
import style0 from "./onsale.vue?vue&type=style&index=0&id=30a25b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a25b66",
  null
  
)

export default component.exports